import React, { useContext, useEffect } from 'react';

import {  RouterProvider } from 'react-router-dom';
import router from './routes';
import axios from 'axios';
import AuthContext from './store/auth-context';
import AuthForm from './Pages/AuthForm/AuthForm';

axios.defaults.withCredentials = true;

function App() {
  const authCtx = useContext(AuthContext)
  const isLoggedIn = authCtx.isLoggedIn


  if(isLoggedIn){
    // const router = require('./routes')

    return (
      <RouterProvider router={router} />
      );
    }else {
      return (
        <AuthForm />
      )
    }
}

export default App;
